module.exports = __webpack_public_path__ + "img/4.6aeb8ac4.jpg";